import React from 'react';
import { styled } from "styled-components";

const AlertWrapper = styled.span`
  display: inline-block;
  text-align: left;
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 5px 10px;
  min-width: 300px;
  min-height: 100px;
  font-size: 14px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#f2f2f2'};
  color: ${({ color }) => color || '#333'};
  border-radius: 4px;
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

function Alert({ children, backgroundColor, color, isVisible }) {
  return (
    <AlertWrapper backgroundColor={backgroundColor} color={color} isVisible={isVisible}>
      {children}
    </AlertWrapper>
  );
}

export default Alert;